export default function EmergencyPlanController(
  $scope,
  alerts,
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
  editEmergencyProcedureDialog
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.hasData = false;

  vm.handleExpand = _handleExpand;
  vm.handleEditEmergencyPlanProcedures = _handleEditEmergencyPlanProcedures;
  vm.statusComplete = _statusComplete;

  _activate();

  // //////// METHODS //////////

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadProcesses();
    }
    return Promise.resolve();
  }

  function _activate() {
    _initPermissions();
    $scope.$on('refreshBCPEmergencyPlan', () => {
      _loadProcesses();
    });
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _statusComplete() {
    return vm.assessmentCustomTestProcedure && vm.assessmentCustomTestProcedure.description;
  }

  function _handleEditEmergencyPlanProcedures($event) {
    _loadEmergencyPlanProcedures().then(() => _openEditCustomTestingProceduresDialog($event, {
      assessmentId: vm.assessmentId,
      procedure: vm.emergencyPlanProcedure,
    }));
  }

  /** *********************************************
   * Private Functions
   */
  function _loadEmergencyPlanProcedures() {
    loaderService.showViewLoader = true;
    return bcpDataService.getEmergencyPlanProcedures(vm.assessmentId)
      .then((response) => {
        vm.emergencyPlanProcedure = response.data ? response.data : {};
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _openEditCustomTestingProceduresDialog($event, locals) {
    ssDialogService.dialogs.bcp.editEmergencyProcedureDialog = ssDialogService.alert(
      editEmergencyProcedureDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editEmergencyProcedureDialog);
  }

  function _loadProcesses() {
    loaderService.showViewLoader = true;
    return bcpDataService.getEmergencyPlanProcedures(vm.assessmentId)
      .then((procedures) => {
        loaderService.showViewLoader = false;
        vm.procedure = procedures.data;
        vm.hasData = true;
      })
      .catch(() => {
        loaderService.showViewLoader = false;
        alerts.error('An error occurred while fetching the Emergency Plan Procedure.');
      });
  }
}

EmergencyPlanController.$inject = [
  '$scope',
  'alerts',
  'bcpDataService',
  'loaderService',
  'ssDialogService',
  'userService',
  'editEmergencyProcedureDialog'
];
